import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class ETDrawingForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		images: Joi.array().min(1).required().label('Drawing'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.images);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 1,
					multiple: false,
					name: 'images',
					accept: 'image/*,application/pdf',
					label: 'Images',
					sublabel: 'Upload ET Drawing Image',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData = { images: [] };

export default ETDrawingForm;
